import { ArrowUpRight, Clock, Mail, PhoneCall, Siren } from "lucide-react";
import { BUSINESS } from "@/lib/data";
import Reveal from "@/components/Reveal";

export default function ServiceAreas() {
  return (
    <section id="areas" data-testid="areas-section" className="relative py-24 sm:py-32 bg-[#171B20]/40 border-y border-white/5">
      <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-16 grid lg:grid-cols-12 gap-14">
        <div className="lg:col-span-7">
          <Reveal>
            <p className="font-mono text-[11px] uppercase tracking-[0.3em] text-[#E06A26] mb-5">Service coverage</p>
            <h2 className="font-display text-2xl sm:text-3xl lg:text-4xl font-semibold tracking-tight mb-12">
              Serving Central & North New Jersey.
            </h2>
          </Reveal>
          <div>
            {BUSINESS.areas.map((a, i) => (
              <Reveal key={a} delay={i * 0.05}>
                <div
                  data-testid={`area-item-${i}`}
                  className="group flex items-center justify-between border-t border-white/10 last:border-b py-5 transition-colors duration-300 hover:border-[#E06A26]/30"
                >
                  <div className="flex items-center gap-6">
                    <span className="font-mono text-xs text-[#606D7A]">{String(i + 1).padStart(2, "0")}</span>
                    <span className="text-base sm:text-lg text-[#F4F2EE]/90 transition-transform duration-300 group-hover:translate-x-2">
                      {a}
                    </span>
                  </div>
                  <ArrowUpRight className="w-4 h-4 text-[#606D7A] group-hover:text-[#E06A26] transition-colors duration-300" />
                </div>
              </Reveal>
            ))}
          </div>
        </div>

        <div className="lg:col-span-5">
          <Reveal delay={0.15}>
            <div data-testid="areas-contact-card" className="rounded-2xl border border-white/10 bg-[#1E242B] p-8 sm:p-10 lg:sticky lg:top-28">
              <p className="font-mono text-[11px] uppercase tracking-[0.3em] text-[#E06A26] mb-8">Dispatch desk</p>
              <a href={BUSINESS.phoneHref} data-testid="areas-phone-link" className="flex items-center gap-4 group mb-6">
                <span className="w-11 h-11 rounded-full bg-[#E06A26]/15 flex items-center justify-center shrink-0">
                  <PhoneCall className="w-4.5 h-4.5 text-[#E06A26]" />
                </span>
                <div>
                  <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-[#606D7A]">Call or text</p>
                  <p className="text-lg font-semibold group-hover:text-[#E06A26] transition-colors duration-300">{BUSINESS.phone}</p>
                </div>
              </a>
              <a href={`mailto:${BUSINESS.email}`} data-testid="areas-email-link" className="flex items-center gap-4 group mb-8">
                <span className="w-11 h-11 rounded-full bg-[#E06A26]/15 flex items-center justify-center shrink-0">
                  <Mail className="w-4.5 h-4.5 text-[#E06A26]" />
                </span>
                <div>
                  <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-[#606D7A]">Email</p>
                  <p className="text-sm font-medium group-hover:text-[#E06A26] transition-colors duration-300 break-all">{BUSINESS.email}</p>
                </div>
              </a>
              <div className="border-t border-white/10 pt-6 space-y-3">
                {BUSINESS.hours.map((h) => (
                  <div key={h.days} className="flex items-center justify-between gap-4">
                    <span className="flex items-center gap-2 text-sm text-[#94A0AC]">
                      <Clock className="w-3.5 h-3.5 text-[#606D7A]" /> {h.days}
                    </span>
                    <span className="font-mono text-xs text-[#F4F2EE]/80">{h.time}</span>
                  </div>
                ))}
              </div>
              <div className="mt-8 flex items-start gap-3 rounded-xl bg-[#E06A26]/10 border border-[#E06A26]/25 p-4">
                <Siren className="w-4 h-4 text-[#E06A26] mt-0.5 shrink-0" />
                <p className="text-xs text-[#F4F2EE]/80 leading-relaxed">
                  Emergency refrigeration failure? We hold same-day slots every morning — call before 9 AM.
                </p>
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
